// Abas da descrição (snippets/body-descricao.liquid): tocar numa aba abre a janela de baixo
// para cima naquele assunto; dentro dela as mesmas abas trocam de assunto; X, fundo ou
// voltar fecham. Uma vez por página, mesmo com mais de uma descrição.
(() => {
  if (window.__bodyDescricao) return;
  window.__bodyDescricao = true;

  const mostrar = (raiz, id) => {
    raiz.querySelectorAll('.body-desc__item').forEach((p) => { p.hidden = p.id !== id; });
    raiz.querySelectorAll('.body-desc__abas--janela .body-desc__aba').forEach((b) => {
      const ativa = b.dataset.alvo === id;
      b.setAttribute('aria-selected', String(ativa));
      b.classList.toggle('is-ativa', ativa);
      if (ativa) b.scrollIntoView({ inline: 'center', block: 'nearest' });
    });
    const paineis = raiz.querySelector('.body-desc__paineis');
    if (paineis) paineis.scrollTop = 0;
  };

  document.addEventListener('click', (e) => {
    const aba = e.target.closest('.body-desc__aba');
    if (aba) {
      const raiz = aba.closest('[data-body-desc]');
      const janela = raiz?.querySelector('.body-desc__janela');
      if (!janela) return;
      mostrar(raiz, aba.dataset.alvo);
      if (!janela.open) {
        janela.showModal();
        document.documentElement.classList.add('body-desc-aberta');
      }
      return;
    }
    if (e.target.closest('.body-desc__fechar')) {
      e.target.closest('dialog')?.close();
      return;
    }
    // Toque no fundo escuro (fora da caixa) fecha.
    if (e.target.matches?.('dialog.body-desc__janela')) e.target.close();
  });

  document.addEventListener('close', (e) => {
    if (e.target.matches?.('dialog.body-desc__janela')) document.documentElement.classList.remove('body-desc-aberta');
  }, true);
})();
